<template>
  <div>
    <v-dialog v-model="dialog" width="350" transition="dialog-bottom-transition" persistent>
      <v-card class="rounded-xl" elevation="24">
        <v-layout fill-height column justify-center align-center :style="bgColor" id="app">
          <!-- <AppBar :colorCode="bgColor.backgroundColor" /> -->

          <v-spacer></v-spacer>
          <v-flex class="mt-5">
            <h1 class="white--text text-center my-1">
              {{ welcomeText }}
            </h1>
          </v-flex>
          <v-flex>
            <v-avatar class="rounded-lg" color="white" size="122" tile>
              <img v-if="employeeImage &&
                this.setting &&
                this.setting.LocationIntegration &&
                this.setting.LocationIntegration.metadata &&
                this.setting.LocationIntegration.metadata
                  .storeTimeClockImageView
                " :src="employeeImage.dataUrl" class="image" alt="EmployeeImage" />

              <img v-else :src="getImage" class="image" alt="EmployeeImage" />
            </v-avatar>
          </v-flex>

          <v-flex shrink>
            <h3 class="mt-5 white--text text-capitalize">
              {{ employee && employee.name }}
            </h3>
          </v-flex>

          <v-flex>
            <h1 class="white--text">{{ time | moment("LT") }}</h1>
            <span class="text-right font-weight-bold">{{ welcomeText }}
            </span>
            <!-- <span
              class="red--text text-right font-weight-bold"
              v-else-if="status === 'clockedIn'"
              >Clocked Out</span
            >
            <span class="green--text text-right font-weight-bold" v-else
              >Clocked In</span
            > -->
          </v-flex>

          <!-- <v-flex class="my-8" style="width: 200px">
            <v-progress-linear
              color="amber"
              indeterminate
              rounded
              height="6"
            ></v-progress-linear>
          </v-flex> -->
          <v-flex class="my-10">
            <v-btn color="primary" @click="$emit('close')" rounded>Close
              <v-progress-circular :rotate="360" class="ml-1" :size="20" :value="value" color="white">
              </v-progress-circular>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import UserImg from "@/assets/images/user.jpeg";

export default {
  props: ["openSubmitDialog", "employee", "status", "employeeImage", "setting", "action"],
  name: "clock-InOut-message",
  data() {
    return {
      dialog: false,
      interval: {},
      value: 0,
      clockOut: false,
      time: new Date(),
      myStyle: {
        backgroundColor: this.status === "clockedIn" ? "#e8ada6" : "#aad3ac",
      },
    };
  },
  beforeDestroy() {
    this.value = 0
    clearInterval(this.interval);
  },
  watch: {
    openSubmitDialog(val) {
      if (val) {
        this.startCounting();
      } else {
        clearInterval(this.interval);
      }
      this.dialog = val
      this.time = new Date()
    },
  },
  computed: {
    welcomeText() {
      // console.log('this.status', this.status)
      if (this.status == "clockedOut") {
        return "Welcome";
      }
      if (this.status == "breakEnd") {
        return "Welcome back";
      }
      if (this.status == "clockedIn") {
        if (this.action === 'breakStart') {
          return "Break Started";
        } else {
          return "Good Bye";
        }

      }
      if (this.status == "breakStart") {
        return "Back To Work";
      }
    },
    bgColor() {
      let value = '#B39DDB'
      // console.log('this.status bgColor', this.status, this.action)

      if (this.status === "clockedOut") {
        value = "#aad3ac";
      }
      if (this.status === "breakStart") {
        value = "#43A047";
      }
      if (this.status === "clockedIn") {
        if (this.action === 'breakStart') {
          value = "#FBC02D";
        } else {
          value = "#e8ada6";
        }
      }


      return {
        backgroundColor: value,
      }
      // return {
      //   backgroundColor: this.status === "clockedIn" ? "#e8ada6" : "#aad3ac",
      // };
    },
    getImage() {
      if (this.employee && this.employee.imageURL) {
        return this.employee.imageURL;
      } else return UserImg;
    },
  },
  methods: {
    startCounting() {
      // console.log("start ed");
      this.interval = setInterval(() => {
        if (this.value === 100) {
          clearInterval(this.interval);
          this.value = 0
          return this.$emit("closeSubmitDialog");
        }
        this.value += 10;
      }, 250);
    },
    close() {
      this.$emit("close");
      // this.$router.push({ name: "clockInOut" });
    },
  },
};
</script>

<style scoped>
.image {
  object-fit: cover !important;
}

.text-right {
  display: block;
}
</style>